import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const RoleDistribution = ({ roleData }) => {
  const COLORS = {
    'Property Owner': '#1E3A8A',
    'Lawyer': '#0EA5E9',
    'Engineer': '#059669',
    'Notary': '#D97706',
    'Broker': '#64748B'
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      const data = payload?.[0];
      return (
        <div className="bg-popover border border-border rounded-lg shadow-elevated p-3">
          <p className="font-medium text-foreground">{data?.name}</p>
          <p className="text-sm text-muted-foreground">
            {data?.value} stakeholders ({((data?.value / roleData?.reduce((sum, item) => sum + item?.value, 0)) * 100)?.toFixed(1)}%)
          </p>
        </div>
      );
    }
    return null;
  };

  const CustomLegend = ({ payload }) => {
    return (
      <div className="flex flex-wrap justify-center gap-4 mt-4">
        {payload?.map((entry, index) => (
          <div key={index} className="flex items-center space-x-2">
            <div 
              className="w-3 h-3 rounded-full" 
              style={{ backgroundColor: entry?.color }}
            />
            <span className="text-sm text-foreground">{entry?.value}</span>
            <span className="text-sm text-muted-foreground">
              ({roleData?.find(item => item?.name === entry?.value)?.value || 0})
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="PieChart" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Role Distribution</h3>
      </div>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={roleData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={2}
              dataKey="value"
            >
              {roleData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[entry?.name]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend content={<CustomLegend />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      {/* Summary Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center">
            <p className="text-2xl font-semibold text-foreground">
              {roleData?.reduce((sum, item) => sum + item?.value, 0)}
            </p>
            <p className="text-sm text-muted-foreground">Total Stakeholders</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-semibold text-foreground">{roleData?.length}</p>
            <p className="text-sm text-muted-foreground">Role Types</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleDistribution;